import { safeJson } from '@/scripts/utils';
import SysText from '../../sysText';

const GroupUpdateMessage = memo(
  ({ payload, noStyle }: { payload: string; noStyle?: boolean }) => {
    const { user_name, group_name } = safeJson(payload, {} as any);
    return (
      <SysText noStyle={noStyle}>
        <Trans
          components={{ name: <a /> }}
          values={{
            name: user_name,
            group_name,
          }}
          i18nKey="messages.chat.message.group.groupUpdate"
        />
      </SysText>
    );
  }
);
export default GroupUpdateMessage;
